import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
import React from 'react'

function PartnerSlider() {
    const settings = {
        infinite: true,
        dots: false,
        arrows:true,
        slidesToShow: 6,
        slidesToScroll: 1,
        lazyLoad: true,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: false
              }
            }
          ]
    };
  return (
    <>
    <section className="section-padding partner-sec">
        <div className="container-fluid">
            <div className="section-header">
                <h3 className="title">Our Partner</h3>
                <p className="text">Lorem ipsum dolor sit amet, consectetur.</p>
            </div>
            <Slider {...settings}>
                <div className="slide-item col-12">
                    <div className="partner_image">
                        <Link to="/shop-details">
                            <img src="/tm/react/toolways/assets/images/product/bakery/21.png" className="image-fit-contain" alt="img"/>
                        </Link>
                    </div>
                </div>
                <div className="slide-item col-12">
                    <div className="partner_image">
                        <Link to="/shop-details">
                            <img src="/tm/react/toolways/assets/images/product/bakery/26.png" className="image-fit-contain" alt="img"/>
                        </Link>
                    </div>
                </div>
                <div className="slide-item col-12">
                    <div className="partner_image">
                        <Link to="/shop-details">
                            <img src="/tm/react/toolways/assets/images/product/bakery/23.png" className="image-fit-contain" alt="img"/>
                        </Link>
                    </div>
                </div>
                <div className="slide-item col-12">
                    <div className="partner_image">
                        <Link to="/shop-details">
                            <img src="/tm/react/toolways/assets/images/product/bakery/24.png" className="image-fit-contain" alt="img"/>
                        </Link>
                    </div>
                </div>
                <div className="slide-item col-12">
                    <div className="partner_image">
                        <Link to="/shop-details">
                            <img src="/tm/react/toolways/assets/images/product/bakery/25.png" className="image-fit-contain" alt="img"/>
                        </Link>
                    </div>
                </div>
                <div className="slide-item col-12">
                    <div className="partner_image">
                        <Link to="/shop-details">
                            <img src="/tm/react/toolways/assets/images/product/bakery/26.png" className="image-fit-contain" alt="img"/>
                        </Link>
                    </div>
                </div>
                <div className="slide-item col-12">
                    <div className="partner_image">
                        <Link to="/shop-details">
                            <img src="/tm/react/toolways/assets/images/product/bakery/23.png" className="image-fit-contain" alt="img"/>
                        </Link>
                    </div>
                </div>
            </Slider>
        </div>
    </section>
    </>
  )
}

export default PartnerSlider